import styled from "styled-components";

const ComicSans = styled.span`
  font-family: "Comic Sans MS", sans-serif;
`;

export default ComicSans;
